<template>
    <div class="footer-content">
        <div class="foot-body">
            <div class="foot-body-item" style="width: 280px;">
                <div class="service-title"><i class="el-icon-service"></i>客服微信</div>
                <div class="service-text service-phone">{{serviceInfo.tel}}</div>
                <div class="service-title"><i class="el-icon-message"></i>客服信箱</div>
                <div class="service-text">{{serviceInfo.mail}}</div>
            </div>
            <div class="foot-body-item">
                <el-popover
                        placement="top-start"
                        title="下载APP"
                        width="380"
                        trigger="hover">
                    <div slot="reference" class="qr-btn">下载APP</div>
                    <div class="qr-code-content">
                        <div class="qr-code-item">
                            <img class="qr-code" src="./../assets/img/dowload.png" alt="">
                            <div class="f-14 grays fw-b">IOS下载</div>
                        </div>
                        <div class="qr-code-item">
                            <img class="qr-code" src="./../assets/img/dowload.png" alt="">
                            <div class="f-14 grays fw-b">安卓下载</div>
                        </div>
                    </div>
                </el-popover>
                <el-select style="width: 190px;" @change="handerMoneyChange" v-model="money" placeholder="选择货币">
                    <el-option v-for="(item,index) in moneyData[0]" :key="index" :label="item.name"
                               :value="item.name"></el-option>
                </el-select>

            </div>
            <div class="foot-body-item item-body">
                <div v-for="(item, index) in itemList" :key="index" class="item-col">
                    <div class="item-name" :class="{'no-line':index===itemList.length-1}">{{item.name}}</div>
                    <div v-for="(it,i) in item.child" :key="i" @click="toPage(it)" class="item-row">{{it.name}}</div>
                </div>
            </div>
        </div>
        <div class="foot-bottom">
            Copyright © {{year}}, Smartisan Digital Co., Ltd. All Rights Reserved.上海旅洋旅游咨询有限公司
            <el-link href="https://beian.miit.gov.cn" :underline="false" target="_blank" class="ml-10 f-12">
                ICP备案号：沪ICP备17054818号-3
            </el-link>
            <!-- <el-link href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" :underline="false" target="_blank" class="ml-10 f-12">
                网安备案号：31011502008408
            </el-link> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        inject: ['reLoad'],
        data() {
            return {
                year: 2020,
                money: '',
                serviceInfo: {},
                moneyData: [],
                itemList: [{
                    name: '关于我们',
                    child: [
                        {name: '公司简介', path: '/aboutUs'},
                        {name: '加入我们', path: '/aboutUs'},
                        {name: '企业文化', path: '/aboutUs'},
                    ]
                }, {
                    name: '关注我们',
                    child: [
                        {name: '关注微博'},
                        {name: '微信公众号'},
                    ]
                }, {
                    name: '入驻平台',
                    child: [
                        {name: '成为房东'},
                        {name: '成为导游'},
                        {name: '入驻说明'},
                    ]
                }, {
                    name: '帮助中心',
                    child: [
                        {name: '支付方式', path: '/question'},
                        {name: '隐私政策', path: '/clause'},
                        {name: '营业执照'},
                        {name: '下载日本自由行小秘书'},
                    ]
                }
                ]
            }
        },
        created() {
            let now = new Date();
            this.year = now.getFullYear();
            this.getServiceInfo();
            this.dymsOne(1);
            this.dymsOne(2);
            let token = window.sessionStorage.getItem('token');
            if (token) {
                this.moneySelect()
            }
            this.$eventBus.$on('isLogin', this.moneySelect)
        },
        beforeDestroy() {
            this.$eventBus.$off('isLogin', this.moneySelect)
        },
        methods: {
            handerMoneyChange() {
                let newVal = this.money;
                if (newVal && this.moneyData[0] && this.moneyData[0].length) {
                    let obj = this.moneyData[0].find(it => it.name === newVal);
                    console.log(obj);
                    this.setMoney(obj.id)
                }
            },
            async getServiceInfo() {
                let [e, data] = await this.$api.getServiceInfoApi()
                this.serviceInfo = data.result;
                this.$store.commit('saveServiceInfo', data.result)
            },
            async dymsOne(id) {
                let [e, data] = await this.$api.dymsOneApi({id})
                if (id === 1) {
                    this.$store.commit('saveServiceAgreement', data.result)
                } else if (id === 2) {
                    this.$store.commit('saveYinsiAgreement', data.result)
                }
            },
            toPage({path}) {
                if (path) {
                    this.$router.push({path})
                }
            },
            async moneySelect() {
                let [e, data] = await this.$api.moneySelectApi();
                if (data.code === 200) {
                    this.moneyData = data.result;
                    this.money = data.result[1] || '';
                }
            },
            async setMoney(id) {
                let [e, data] = await this.$api.setMoneyApi({id});
                if (data.code === 200) {
                    this.moneySelect();
                    this.reLoad();
                    this.$message.success('设置成功！');
                } else {
                    this.$message.warning(data.error);
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .footer-content {
        background-color: #e1eef5;
        margin-top: 20px;

        .foot-body {
            width: 1200px;
            height: 290px;
            margin: auto;
            padding-top: 60px;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
        }

        .foot-bottom {
            width: 100%;
            height: 40px;
            line-height: 40px;
            border-top: 1px solid #cccccc;
            font-size: 12px;
            color: #999;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;

        }
    }

    .service-title {
        font-size: 18px !important;
        margin-top: 10px;
        text-align: left;
    }

    .service-phone {
        color: #e44646;
    }

    .service-text {
        font-size: 18px;
        text-align: left;
        padding: 6px 0;
        font-weight: bold;
    }

    .foot-body-item {
        position: relative;
        padding: 0 20px;
        box-sizing: border-box;

        &::before {
            content: '';
            position: absolute;
            right: 0;
            top: 20px;
            width: 1px;
            height: 140px;
            background-color: #c5ddea;
        }

        &:last-child {
            &::before {
                display: none;
            }
        }
    }

    .qr-btn {
        width: 190px;
        height: 42px;
        line-height: 42px;
        background-color: #e44646;
        border-radius: 6px;
        margin-bottom: 10px;
        cursor: pointer;
        color: #ffffff;
        text-align: center;
    }

    .qr-code-content {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .qr-code-item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
    }

    .qr-code {
        width: 140px;
        height: 140px;
        object-fit: contain;
        margin: 10px;
    }

    .item-body {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .item-col {
        padding: 0 10px;
    }

    .item-name {
        font-size: 16px;
        color: #2a2a2a;
        position: relative;
        width: 106px;
        margin-bottom: 10px;
        text-align: center;

        &::before {
            content: '';
            position: absolute;
            right: -10px;
            top: 50%;
            transform: translate(0, -50%);
            width: 2px;
            height: 16px;
            background-color: #9da6aa;
        }
    }

    .no-line {
        &::before {
            display: none;
        }
    }

    .item-row {
        color: #2a2a2a;
        text-align: center;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        width: 106px;
        word-break: keep-all;
        cursor: pointer;
    }
</style>
